import { useState } from 'react';

import { type IMediaProps, Media } from '../Media/Media'
import { type IFileViewerProps } from '@ui/blocks/FileViewer/FileViewer'
import { FileViewerModal } from '@ui/blocks/FileViewer/FileViewerModal'
import { SingleFileViewerModal } from '@ui/blocks/SingleFileViewer/SingleFileViewerModal'

export interface MediaWithViewerAnalyticsIds {
  /**
   * Analytics ID for the media thumbnail/preview trigger
   */
  media?: string
}

export interface IMediaWithViewerProps
  extends Omit<IMediaProps, 'viewer' | 'analyticsId'> {
  /**
   * Analytics IDs for tracking user interactions within the media viewer.
   * @see MediaWithViewerAnalyticsIds
   */
  analyticsIds?: MediaWithViewerAnalyticsIds
  files?: IFileViewerProps['files']
  initialSelectedFileIndex?: number
}

export const MediaWithViewer = (props: IMediaWithViewerProps) => {
  const { analyticsIds, files, onClick, src, name, initialSelectedFileIndex } =
    props

  const [viewerIsOpen, setViewerIsOpen] = useState(false)

  const showViewer = () => {
    setViewerIsOpen(true)
  }

  const hideViewer = () => {
    setViewerIsOpen(false)
  }

  const handleClick = (e) => {
    e.preventDefault()

    showViewer()

    if (onClick) {
      onClick(e)
    }
  }

  const attachments = files || [{ file: src, name }]

  return (
    <>
      <Media
        {...props}
        analyticsId={analyticsIds?.media}
        onClick={handleClick}
      />

      {attachments.length > 1 ? (
        <FileViewerModal
          open={viewerIsOpen}
          files={attachments}
          initialSelectedFile={
            initialSelectedFileIndex >= 0
              ? attachments[initialSelectedFileIndex]
              : null
          }
          onDismiss={hideViewer}
        />
      ) : (
        <SingleFileViewerModal
          file={attachments[0]}
          onDismiss={hideViewer}
          open={viewerIsOpen}
        />
      )}
    </>
  )
}
